import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getWoundCareSelector } from '../selectors'
import { setAddToTimeLine } from '../store/woundCare.actions'
import { WoundCareConstants } from '../store/woundCare.constants'
import { IWoundCareState } from '../store/woundCare.types'
import { addWoundCareItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveWoundCare() {
  let woundCareState: IWoundCareState = yield select(getWoundCareSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    // When mutliple actions are selected, "null" is used to match the behavior of the WEB implementation.
    // If only one action is selected, its name is set as the value.
    woundCareState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: woundCareState,
      actionField: (s) => (s.actions.length === 1 ? s.actions[0].name : null),
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    woundCareState = handleNemsisCodeError(error, woundCareState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.woundCareStateList && pcrDoc.patient?.woundCareStateList.length) {
    const index = pcrDoc.patient?.woundCareStateList?.findIndex((woundCare) => woundCare.key === woundCareState.key)
    if (index !== -1) {
      pcrDoc.patient.woundCareStateList[index] = woundCareState
    } else {
      pcrDoc.patient?.woundCareStateList.push(woundCareState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, woundCareStateList: [woundCareState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addWoundCareItem())
  } catch (e) {
    yield put(throwPcrException(`saveWoundCare() error: ${e}`))
  }
}

export function* saveWoundCareSaga() {
  yield takeLatest(
    [
      WoundCareConstants.SAVE_WOUND_CARE,
      WoundCareConstants.SET_DATE,
      WoundCareConstants.SET_TIME,
      WoundCareConstants.SET_DATE_TIME,
      WoundCareConstants.SET_ASSESSED_BY,
      WoundCareConstants.SET_RESPONSE,
      WoundCareConstants.SET_RESPONSE_PNNV,
      WoundCareConstants.SET_PROCEDURE_COMPLICATIONS,
      WoundCareConstants.SET_AUTHORIZATION,
      WoundCareConstants.SET_ATTEMPTS,
      WoundCareConstants.SET_ACTIONS,
      WoundCareConstants.SET_SITE,
      WoundCareConstants.SET_SIZE,
      WoundCareConstants.SET_ROLE_PERFORMING,
      WoundCareConstants.SET_ROLE_PERFORMING_PNNV,
      WoundCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      WoundCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      WoundCareConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveWoundCare
  )
}
